import Styled from 'styled-components'

export const Brand = Styled.h1`
`

export const Banner = Styled.div`
`

export const CotainerProduct = Styled.div`
`

export const Cashback = Styled.div`
`
export const Space = Styled.div`
`

export const SearchResultText = Styled.span`
  font-weight: bold;
  font-size: ${props => props.hasDidYouMean ? '13px' : '14px'};
`;

export const DidYouMeanText = Styled.span`
  font-weight: bold;
  font-size: 14px;
`;

/* Desktop: alinha o Container do Bootstrap ao padrão do header (1320/32) */
export const PageWrap = Styled.div`
  @media (min-width: 1024px) {
    .container {
      max-width: 1320px;
      padding-left: 32px;
      padding-right: 32px;
    }
  }
`;

/* Desktop: busca em 2 colunas (filtros 280px + produtos) */
export const ListingLayout = Styled.div`
  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 280px minmax(0, 1fr);
    gap: 32px;
    align-items: start;

    .product-grid {
      margin-left: 0;
      margin-right: 0;
    }
    .product-grid .col-6 {
      flex: 0 0 25%;
      max-width: 25%;
      width: 25%;
    }
  }
`;
